<template>
  <div id="templateEditorGroup">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">{{ admin }}</li>
      <li class="breadcrumb-item">{{ setting }}</li>
      <li class="breadcrumb-item active">
        <router-link
          :to="url"
          v-on:click.native="executeCancelNewTemplateEditorGroup"
        >{{ templateEditorGroup }}</router-link>
      </li>
    </ol>
     <div class="container-fluid card-title-admin">
        <h1>{{ templateEditorGroup }}</h1>
    </div>
    <div class="container-fluid">
      <div class="card">
        <div class="tab-content noborder">
          <div class="tab-pane active" id="tabTemplateEditorGroupTable" role="tabpanel">
            <div class="row align-btns">
              <div class="col-lg-12">
                <button
                  id="btnAdd"
                  type="button"
                  class="btn btn-primary"
                  @click="onNewTemplateEditorGroup"
                >
                  <i class="fa fa-plus"></i>
                  <span>{{ add }}</span>
                </button>
                <button
                  id="btnSave"
                  type="button"
                  class="btn btn-success"
                  @click="confirmSaveTemplateEditorGroup"
                  :disabled="disableButton"
                >
                  <i class="fa fa-floppy-o"></i>
                  <span>{{ save }}</span>
                </button>
                <button
                  id="btnDelete"
                  type="button"
                  class="btn btn-danger"
                  @click="confirmDeleteTemplateEditorGroup"
                  :disabled="disableButton"
                >
                  <i class="fa fa-trash"></i>
                  <span>{{ del }}</span>
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <bootstrapTable
                  :configurations="tableTemplateEditorGroupConfiguration"
                  :datas="tableTemplateEditorGroupData"
                  id="tableTemplateEditorGroup"
                  :onCheck="onTableCheckTemplateEditorGroup"
                  :onCheckAll="onTableCheckTemplateEditorGroup"
                  :onUncheck="onTableCheckTemplateEditorGroup"
                  :onUncheckAll="onTableCheckTemplateEditorGroup"
                  ref="tableTemplateEditorGroup"
                  :results="tableTemplateEditorGroupResult"
                ></bootstrapTable>
              </div>
            </div>
          </div>
          <div class="tab-pane nopadding" id="tabTemplateEditorGroupDetail" role="tabpanel">
            <div class="card-body" style="padding:30px;">
              <div class="row">
               <div v-if="rowIdSelected > 0">
                      <h1 style="margin-top: 10px; font-size: 30px;font-weight: lighter;color: #303C54;">Modifica</h1>
                      </div>
                      <div v-else>
                      <h1 style="margin-top: 10px; font-size: 30px;font-weight: lighter;color: #303C54;">Aggiungi</h1>
                      </div>
                <pageDetail
                  functions="AdminSettingTemplateEditorGroup"
                  :configurations="detailTemplateEditorGroupConfiguration"
                  :jsonValue="detailTemplateEditorGroupData"
                ></pageDetail>
              </div>
              <div class="row">
                <div class="col-12 text-right">
                  <button
                    type="button"
                    class="btn btn-danger"
                    data-dismiss="modal"
                    @click="confirmCancelNewTemplateEditorGroup"
                  ><i class="fa fa-times"></i>&nbsp; {{ cancel }}</button>
                  <button
                    type="button"
                    class="btn btn-success"
                    @click="confirmSaveNewTemplateEditorGroup"
                  ><i class="fa fa-floppy-o"></i>&nbsp; {{ save }}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BootstrapTable from "@/components/BootstrapTable.vue";
import PageDetail from "@/components/PageDetail.vue";

export default {
  name: "templateEditorGroup",
  components: {
    BootstrapTable,
    PageDetail
  },
  data() {
    return {
      add: dictionaryHelpers.getDictionary("Add"),
      admin: dictionaryHelpers.getDictionary("Admin"),
      cancel: dictionaryHelpers.getDictionary("Cancel"),
      del: dictionaryHelpers.getDictionary("Delete"),
      deleteCompleted: dictionaryHelpers.getDictionary("DeleteCompleted"),
      detailTemplateEditorGroupConfiguration: [],
      detailTemplateEditorGroupData: {},
      disableButton: true,
      insertCompleted: dictionaryHelpers.getDictionary("InsertCompleted"),
      newTemplateEditorGroup: dictionaryHelpers.getDictionary(
        "NewTemplateEditorGroup"
      ),
      tableTemplateEditorGroupConfiguration: [],
      tableTemplateEditorGroupData: [],
      tableTemplateEditorGroupResult: [],
      templateEditorGroup: dictionaryHelpers.getDictionary(
        "TemplateEditorGroup"
      ),
      rowsSelected: 0,
      save: dictionaryHelpers.getDictionary("Save"),
      setting: dictionaryHelpers.getDictionary("Setting"),
      updateCompleted: dictionaryHelpers.getDictionary("UpdateCompleted"),
      url: window.location.pathname
    };
  },
  created() {
    spinnerHelpers.show();
    var templateEditorGroup = this;
  
    adminConfigurationServices.getFunctionality(function(result) {
   
      templateEditorGroup.detailTemplateEditorGroupConfiguration = result.data.tabsConfigurations[0].pageConfigurations;
      templateEditorGroup.tableTemplateEditorGroupConfiguration = result.data.tablesConfigurations[0].tablesConfigurations;
      templateEditorGroup.loadTemplateEditorGroupTable();
    });
  },
  methods: {
    loadTemplateEditorGroupTable() {
      var templateEditorGroup = this;

      templateEditorGroupServices.getDto(function(result) {
        templateEditorGroup.tableTemplateEditorGroupData = result.data;
        spinnerHelpers.hide();
      });
    },
    
    templateEditorGroupFormatter (value, row, index, field) {
      var templateEditorGroup = this
      var html = '<div class="container-fluid nopadding" style="width:80px;"><div class="row">'
        html += 
        '<button class="btn btn-success" onclick="templateEditorGroup.__vue__.executeOpenDetail(' +
        row.id +
        ')"><i class="fa fa-pencil" title="' +
        this.openDetail +
        '" /></button>';
        html += 
        '<button class="btn btn-info" onclick="templateEditorGroup.__vue__.clone(' +
        row.id +
        ')"><i class="fa fa-files-o"/></button>';

      if (functionHelpers.isValued(this.tableTemplateEditorGroupResult)) {
        $.each(this.tableTemplateEditorGroupResult, function (i, result) {
          if (result.id == row.id) {
            if (result.success) {
              html +=
                '<div class="col-1"><i class="fa fa-check text-success" title="'
              if (functionHelpers.isValued(result.message)) {
                html += result.message
              } else {
                html += templateEditorGroup.updateCompleted
              }
              html += '" /></div>'
            } else {
              html +=
                '<div class="col-1"><i class="fa fa-exclamation-triangle text-danger" title="' +
                result.message +
                '" /></div>'
            }
          }
        })
        return html
      }
      html += '</div></div>'
    },

    executeOpenDetail (id) {
          spinnerHelpers.show()
          var templateEditorGroup = this
          this.rowIdSelected = id

            $.each(this.tableTemplateEditorGroupData, function (i, row) {
              if (templateEditorGroup.rowIdSelected == row.id) {
                templateEditorGroup.detailTemplateEditorGroupData = row;
              }
            })
          $('#tabTemplateEditorGroupTable').removeClass('active')
          $('#tabTemplateEditorGroupDetail').addClass('active')
          spinnerHelpers.hide()
        },

    clone(id){
      spinnerHelpers.show();
      var templateEditorGroup = this;
      templateEditorGroupServices.clone(id, function(result) {
        console.log(result);
        templateEditorGroup.loadTemplateEditorGroupTable();
        notificationHelpers.success(dictionaryHelpers.getDictionary("CloneCompleted"));
      });
        spinnerHelpers.hide();
    },


    onNewTemplateEditorGroup() {
      spinnerHelpers.show();
      this.detailTemplateEditorGroupData = {};
      $("#tabTemplateEditorGroupTable").removeClass("active");
      $("#tabTemplateEditorGroupDetail").addClass("active");
      spinnerHelpers.hide();
    },

    confirmSaveTemplateEditorGroup() {
      if (confirm(dictionaryHelpers.getDictionary("ConfirmSave"))) {
        this.executeSaveTemplateEditorGroup();
      }
    },

    executeSaveTemplateEditorGroup() {
      spinnerHelpers.show();
      var templateEditorGroup = this;
      this.rowsSelected = 0;
      this.tableTemplateEditorGroupResult = [];

      $.each(this.$refs.tableTemplateEditorGroup.getRowSelected(), function(i,row) {
        var rowToSave = row;
        rowToSave.idFunctionality = menuHelpers.getIdFunctionByAdminUrl();
        templateEditorGroup.rowsSelected = templateEditorGroup.rowsSelected + 1;
        templateEditorGroupServices.update(
          rowToSave,
          function() {
            templateEditorGroup.checkAllIsSaved();
            templateEditorGroup.tableTemplateEditorGroupResult.push({
              id: rowToSave.id,
              success: true
            });
            notificationHelpers.success(templateEditorGroup.updateCompleted);
          },
          function(response) {
            templateEditorGroup.checkAllIsSaved();
            templateEditorGroup.tableTemplateEditorGroupResult.push({
              id: rowToSave.id,
              success: false,
              message: response
            });
            notificationHelpers.error(response);
          }
        );
      });
    },

    confirmDeleteTemplateEditorGroup() {
      if (confirm(this.confirmDelete)) {
        this.executeDeleteTemplateEditorGroup();
      }
    },

    executeDeleteTemplateEditorGroup() {
      spinnerHelpers.show();
      var templateEditorGroup = this;
      this.rowsSelected = 0;
      this.tableTemplateEditorGroupResult = [];

      $.each(this.$refs.tableTemplateEditorGroup.getRowSelected(), function(
        i,
        row
      ) {
        templateEditorGroup.rowsSelected = templateEditorGroup.rowsSelected + 1;

        templateEditorGroupServices.del(
          row.id,
          function() {
            templateEditorGroup.checkAllIsSaved();
            notificationHelpers.success(templateEditorGroup.deleteCompleted);
          },
          function(response) {
            templateEditorGroup.checkAllIsSaved();
            templateEditorGroup.tableTemplateEditorGroupResult.push({
              id: rowToSave.id,
              success: false,
              message: response
            });
            notificationHelpers.error(response);
          }
        );
      });
    },

    onTableCheckTemplateEditorGroup() {
      var countRowSelected = this.$refs.tableTemplateEditorGroup.countRowSelected();
      if (countRowSelected == 0) {
        this.disableButton = true;
      } else {
        this.disableButton = false;
      }
    },

    confirmCancelNewTemplateEditorGroup() {
      if (confirm(dictionaryHelpers.getDictionary("ConfirmCancel"))) {
        this.executeCancelNewTemplateEditorGroup();
      }
    },

    executeCancelNewTemplateEditorGroup() {
      spinnerHelpers.show();
      this.detailTemplateEditorGroupData = {};
      $("#tabTemplateEditorGroupTable").addClass("active");
      $("#tabTemplateEditorGroupDetail").removeClass("active");
      spinnerHelpers.hide();
    },

    confirmSaveNewTemplateEditorGroup() {
      if (confirm(dictionaryHelpers.getDictionary("ConfirmSave"))) {
        this.executeSaveNewTemplateEditorGroup();
      }
    },

    executeSaveNewTemplateEditorGroup() {
      spinnerHelpers.show();
      var templateEditorGroup = this;
      this.detailTemplateEditorGroupData.idFunctionality = menuHelpers.getIdFunctionByAdminUrl();

      templateEditorGroupServices.insert(
        this.detailTemplateEditorGroupData,
        function(result) {
          templateEditorGroup.tableTemplateEditorGroupResult.push({
            id: result.data,
            success: true,
            message: templateEditorGroup.insertCompleted
          });
          notificationHelpers.success(templateEditorGroup.insertCompleted);
          templateEditorGroup.loadTemplateEditorGroupTable();
          $("#tabTemplateEditorGroupTable").addClass("active");
          $("#tabTemplateEditorGroupDetail").removeClass("active");
        }
      );
    },

    checkAllIsSaved() {
      this.rowsSelected = this.rowsSelected - 1;
      if (this.rowsSelected == 0) {
        this.disableButton = true;
        this.loadTemplateEditorGroupTable();
      }
    }
  }
};
</script>

<style>
.card-title-admin h1{
  font-size:40px;
  font-weight: lighter;
  color:#303C54;
}
.align-btns {
    position: absolute;
    z-index: 1;
    margin-top: 10px;
}
#idTemplateEditorType + .select2 {
    height: 56px;
    float: left;
    padding-top: 10px;
}

</style>